import { render } from "./EditReportCard.vue?vue&type=template&id=4ab2bd5b"
import script from "./EditReportCard.vue?vue&type=script&lang=js"
export * from "./EditReportCard.vue?vue&type=script&lang=js"

import "./EditReportCard.vue?vue&type=style&index=0&id=4ab2bd5b&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__